export default "__VITE_ASSET__fe9c0080__"